import React from "react";
import { Container, CenterDiv, Suport,/* LogoImage */ LogoCanto } from "./styles.js";
import RegisterView from "../../views/Register/index.jsx";
/* import logo from '../../assets/LogoPos2.png';
 */
import logoCanto from "../../assets/logoCanto.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
function Register() {
  return (
    <Container>
      <CenterDiv>
        <LogoCanto src={logoCanto} alt="Logo Cantoneira" />

        <h2>Primeira etapa!</h2>
        <h4>Preencha os campos abaixo com as suas informações</h4>
        <RegisterView />

        {/*  <LogoImage src={logo} alt="Logo CEDAP" /> */}
      </CenterDiv>
           <Suport href="https://wa.me/5547991153595" target="_blank">
                                <u>Suporte</u>
                                <FontAwesomeIcon icon={faWhatsapp} color="#25d366" />
                              </Suport>
    </Container>
  );
}

export default Register;
